module.exports = __webpack_public_path__ + "img/ic-usdt.01f91da1.svg";